import React from 'react';

import ingredientsStyle from './recipe-ingredients.module.css';

type Props = {
  informations: string[];
  ingredients: string[];
  pid: string;
};

const RecipeIngredients = ({ informations, ingredients, pid }: Props) => {
  return (
    <div
      className={`recipe-sticker recipe-content recipe-${pid}-sticker ${ingredientsStyle.wrapper}`}
    >
      <h2>Ingrédients</h2>
      <ul>
        {ingredients.map((ingredient, index) => (
          <li key={`ingredient${index}`}>{ingredient}</li>
        ))}
      </ul>
      <ul className={ingredientsStyle.information}>
        <li>
          <strong>Pour : </strong>
          {informations[0]}
        </li>
        <li>
          <strong>En : </strong>
          {informations[1]}
        </li>
        <li>
          <strong>Il te faut : </strong>
          {informations[2]}
        </li>
      </ul>
    </div>
  );
};

export default RecipeIngredients;
